import { KB_EARNING } from "../../actions/type";

export default function ledger(state = {}, action) {
    switch (action.type) {
        case KB_EARNING:
            return action.payload;;
        default:
            return state
    }
}